var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-help"},[_c('ul',_vm._l((_vm.menus),function(menu,index){return _c('li',[_c('a',{staticClass:"menu-item",class:{active: index === _vm.currIndex},attrs:{"href":"javascript: void(0)"},on:{"click":function($event){return _vm.changeMenu(index)}}},[_vm._v("\n        "+_vm._s(menu.type)+"\n      ")])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d4e1799","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/help/components/sidebar.vue
// module id = null
// module chunks = 